import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import {
  DropDownSelector,
  Tabs,
  TableBox,
  Checkbox
} from '@lk-gtcom/ecomlab-components';
import './CheckingOVH.scss';
import useGeneralStore from '../../store/general';
import customHeaders, { getSpace } from '../../common/headers';
import { fetchApiFilterVer3, fetchMPOfferIdFilter } from '../../common/filtersFunc';
import { OlegHttps } from '../../fetchUrls';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { options_prop_mp } from '../../common/globalVariables';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
  { label: 'Все товары', value: 'all_table' },
  { label: 'Товары с отклонением по периметру > 100%', value: 'perimetr' },
  { label: 'Один из параметров по отклонению габарита меньше -15%  или больше 5%', value: 'deviation' },
  { label: 'Отклонение объемного веса от среднего значения объемного веса', value: 'volumetric' },
];

const CheckingOVH = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'checking-OVH');
  const requestControllerRef = useRef(new RequestController());

  const [pageValue, setPageValue] = useState('all_table');

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;
  const activeTab = useParams()['*'];

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'warehouse', type: 'multi' },
    { key: 'сampaign', type: 'multi' },
    { key: 'offerId', type: 'multi' },
    { key: 'offerId', type: 'multi' },
    { key: 'zero', type: 'single' },
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [offerIdData, setOfferIdData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState(options_prop_mp[0]?.value)
  const [selectedApi, setSelectedApi] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCampaign, setSelectedCampaign] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedOfferId, setSelectedOfferId] = useState([{ label: 'Все', value: 'all' }]);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [warehousePage, setWarehousePage] = useState(1);
  const [campaignPage, setCampaignPage] = useState(1);
  const [offerIdPage, setOfferIdPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [warehouseQuery, setWarehouseQuery] = useState('');
  const [campaignQuery, setCampaignQuery] = useState('');
  const [offerIdQuery, setOfferIdQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)
  const [totalWarehouse, setTotalWarehouse] = useState(0);
  const [totalCampaign, setTotalCampaign] = useState(0);
  const [totalOfferId, setTotalOfferId] = useState(0)

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [tableUrl, setTableUrl] = useState('');
  const [tableBody, setTableBody] = useState(null);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const [sort, setSort] = useState(null);
  const { setLoading, setFetchedData, setHeaders, setFilters } = setTableFuncs;
  const [checkZero, setCheckZero] = useState(false);

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.warehouse) setSelectedWarehouse(urlParams.warehouse)
        if (urlParams.сampaign) setSelectedCampaign(urlParams.сampaign)
        if (urlParams.offerId) setSelectedOfferId(urlParams.offerId)
        if (urlParams.zero) setCheckZero(urlParams.zero?.value)

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort, filters;
    if (params) {
      [sort, filters] = params;
    }

    setLoading(true);

    const url = `${OlegHttps}/api/v1/ovh/checking/table/${pageValue}${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`

    const body = JSON.stringify({
      filters,
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      campaign_id_list: getValueMultiFilter(selectedCampaign),
      offer_id_list: getValueMultiFilter(selectedOfferId),
      with_stock_filter: !checkZero,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        setTable(json);
        setTableUrl(url);
        setTableBody(body);
      })
      .catch(handleRequestError)
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      });
  };

  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalApi,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      setTotal: setTotalApi,
      filter: 'api_id',
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      set: setCategoryData,
      searchParam: categoryQuery,
      selectedShop: selectedMarketplace,
      setTotal: setTotalCategory,
      filter: 'category',
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalBrand,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      selectedShop: selectedMarketplace,
      set: setBrandData,
      setTotal: setTotalBrand,
      filter: 'brand',
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  const filtersCampaign = () => {
    const controller = requestControllerRef.current.createController('campaign');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: campaignPage,
      searchParam: campaignQuery,
      selectedShop: selectedMarketplace,
      set: setCampaignData,
      setTotal: setTotalCampaign,
      filter: 'status_advertising',
    })?.finally(() => {
      requestControllerRef.current.removeController('campaign');
    })
  };

  const filtersWarehouse = () => {
    const controller = requestControllerRef.current.createController('warehouse');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: warehousePage,
      searchParam: warehouseQuery,
      selectedShop: selectedMarketplace,
      set: setWarehouseData,
      setTotal: setTotalWarehouse,
      filter: 'warehouse',
    })?.finally(() => {
      requestControllerRef.current.removeController('warehouse');
    })
  };

  const filtersOfferId = () => {
    const controller = requestControllerRef.current.createController('offer');

    fetchMPOfferIdFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      page: offerIdPage,
      apiData,
      categoryData,
      selectedCategory,
      brandData,
      selectedBrand,
      dateFrom,
      dateTo,
      searchParam: offerIdQuery,
      selectedApi,
      setOfferIdData: (e) => setOfferIdData(e),
      setTotal: setTotalOfferId
    })?.finally(() => {
      requestControllerRef.current.removeController('offer');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi();
  }, [isFilterRequest, apiPage, apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory();
  }, [isFilterRequest, dateFrom, dateTo, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand();
  }, [isFilterRequest, dateFrom, dateTo, brandPage, brandQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCampaign();
  }, [isFilterRequest, dateFrom, dateTo, campaignPage, campaignQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersWarehouse();
  }, [isFilterRequest, dateFrom, dateTo, warehousePage, warehouseQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersOfferId();
  }, [isFilterRequest, dateFrom, dateTo, offerIdPage, offerIdQuery]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);


  useEffect(() => {
    if(!isReady) return
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [isTableRequest, pageValue, checkZero]);

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  return (
    <>
      <div className="checking-OVH">
        <TitlePage
          title='Проверка ОВХ'
        />

        <div className="checking-OVH__filters">
          <FilterContainer
            loading={isSaved}
            saveFilters={saveFilters}
            clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
            onReset={(e) => {
              setSelectedMarketplace([])
              setSelectedCategory([]);
              setSelectedBrand([]);
              setSelectedApi([]);
              setSelectedCampaign([]);
              setSelectedWarehouse([]);
              setSelectedOfferId([]);
              resetTable();
              updateURL({
                mp: null,
                api: null,
                category: null,
                brand: null,
                warehouse: null,
                offerId: null,
                сampaign: null,
                offerId: null,
                zero: null
              });
              setIsTableRequest(!isTableRequest)
              setIsFilterRequest(!isFilterRequest);
            }}
          >
            <DropDownSelector
              options_prop={options_prop_mp}
              state={selectedMarketplace}
              setState={setSelectedMarketplace}
              placeholder="Площадка"
              defaultValue={options_prop_mp[0]}
              total={options_prop_mp?.length}
              onBlur={() => {
                updateURL({ mp: selectedMarketplace });
                filtersApi();
                filtersBrand();
                filtersCampaign();
                filtersCategory();
                filtersOfferId();
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              state={selectedApi}
              options_prop={apiData}
              setState={setSelectedApi}
              placeholder="Магазин"
              total={totalApi}
              fetchCallback={setApiPage}
              setInputChange={setApiQuery}
              multi
              onBlur={() => {
                updateURL({ api: selectedApi });
                filtersCategory();
                filtersBrand();
                filtersCampaign();
                filtersWarehouse();
                filtersOfferId();
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={categoryData}
              state={selectedCategory}
              setState={setSelectedCategory}
              placeholder="Категория"
              total={totalCategory}
              fetchCallback={setCategoryPage}
              setInputChange={setCategoryQuery}
              multi
              onBlur={() => {
                updateURL({ category: selectedCategory });
                filtersBrand();
                filtersCampaign();
                filtersWarehouse();
                filtersOfferId();
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={brandData}
              state={selectedBrand}
              setState={setSelectedBrand}
              placeholder="Бренд"
              total={totalBrand}
              fetchCallback={setBrandPage}
              setInputChange={setBrandQuery}
              multi
              onBlur={() => {
                updateURL({ brand: selectedBrand });
                filtersCampaign();
                filtersWarehouse();
                filtersOfferId();
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={warehouseData}
              state={selectedWarehouse}
              setState={setSelectedWarehouse}
              placeholder="Склад"
              total={totalWarehouse}
              fetchCallback={setWarehousePage}
              setInputChange={setWarehouseQuery}
              multi
              onBlur={() => {
                updateURL({ warehouse: selectedWarehouse });
                filtersCampaign();
                setIsTableRequest(!isTableRequest)
              }}
            />


            <DropDownSelector
              options_prop={campaignData}
              state={selectedCampaign}
              setState={setSelectedCampaign}
              placeholder="Кампания"
              total={totalCampaign}
              fetchCallback={setCampaignPage}
              setInputChange={setCampaignQuery}
              multi
              onBlur={() => {
                updateURL({ campaign: selectedCampaign });
                filtersWarehouse();
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={offerIdData}
              state={selectedOfferId}
              setState={setSelectedOfferId}
              placeholder="OfferId"
              total={totalOfferId}
              multi={true}
              fetchCallback={setOfferIdPage}
              setInputChange={setOfferIdQuery}
              onBlur={() => {
                updateURL({ offerId: selectedOfferId });
                filtersCampaign();
                filtersWarehouse();
                setIsTableRequest(!isTableRequest)
              }}
            />

            <Checkbox
              value={checkZero}
              onChange={(e) => {
                updateURL({
                  zero: {
                    label: e,
                    value: e
                  }
                });
                setCheckZero(e)
              }}>
              Без нулевого остатка
            </Checkbox>
          </FilterContainer>
        </div>

        <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
        />

        <TableBox
          sort={sort}
          {...tableProps}
          paginator={true}
          ref={paginatorRef}
          onCheck={(e) => setCheckedProducts(e)}
          fetchCallback={(e) => fetchTableData(e)}
          sortingFunc={(e) => {
            fetchTableData(e);
          }}
          tableUrl={`/ovh/extract/to_excel/table/${pageValue}`}
          tableBody={tableBody}
        />
      </div>
    </>
  );
};

export { CheckingOVH };
